module.exports = __webpack_public_path__ + "static/media/tem.efa181e9.svg";